import { useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { getWishlistExportData } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistExport/selectors';
import { getWishlistPrintData } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistPrint/selectors';
import { getWishlistSendData } from 'b2b-apps/shop/myAccount/wishlists/redux/wishlistActions/wishlistSend/selectors';

type UseWishlistActionsDataReturnType = {
  export: RemoteRecord<Record<string, any>>;
  print: RemoteRecord<Record<string, any>>;
  send: RemoteRecord<Record<string, any>>;
};

const useWishlistActionsData = (): UseWishlistActionsDataReturnType => ({
  export: useSelector(getWishlistExportData),
  print: useSelector(getWishlistPrintData),
  send: useSelector(getWishlistSendData),
});

export type { UseWishlistActionsDataReturnType };
export { useWishlistActionsData };
